import React, { Component, useEffect } from 'react';
import '../App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import tg from '../assets/telegram.png';
import x from '../assets/twitter2.png';
import instagram from '../assets/instagram.png';
import logo from '../assets/logo.png';
import stones from '../assets/stones.png';

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

const xLink = () => {
    window.open("https://twitter.com/FROGY_TOKEN");
}

const insta = () => {
    window.open("#");
}

const teleG = () => {
    window.open("#");
}

const email = () => {
    window.open("3");
}

class Footer extends Component {

    render() {
        return (

            <div>

                <div class="boxWrap2Footer">

                    <div class="footer">

                        <img class="logoF" src={logo} />
                        <div class="iconsF">
                            <img onClick={teleG} src={tg} />
                            <img onClick={xLink} src={x} />
                            <img onClick={insta} src={instagram} />

                        </div>

                        <div class="copyright">Copyright © 2024 FROGY. All Rights Reserved</div>
                    </div>

                </div>
            </div>
        )
    }
}

export default Footer;

